import { apiSlice } from "services/apiSlice";

export const quoteApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createQuote: builder.mutation({
      query: (quoteData) => ({
        url: "quotes",
        method: "POST",
        body: quoteData,
      }),
      invalidatesTags: ["quotes"],
    }),
    createQuoteDraft: builder.mutation({
      query: (quoteData) => ({
        url: "quotes/draft",
        method: "POST",
        body: quoteData,
      }),
      invalidatesTags: ["quotes"],
    }),

    getQuotes: builder.query({
      query: ({ companyId }) => `quotes/company/${companyId}`,
      providesTags: ["quotes"],
    }),
    updateQuoteStatus: builder.mutation({
      query: ({ id, quoteStatus }) => ({
        url: `quotes/${id}/${quoteStatus}`,
        method: "PATCH",
        body: { quoteStatus },
      }),
      invalidatesTags: ["quotes"],
    }),
    getNextQuoteNumber: builder.query({
      query: (id) => `quotes/next-number/${id}`,
    }),
    updateQuote: builder.mutation({
      query: ({ id, ...fields }) => ({
        url: `quotes/${id}`,
        method: "PATCH",
        body: fields,
      }),
      invalidatesTags: ["quotes"],
    }),
    getQuotesByStatus: builder.query({
      query: ({ status, filter }) => {
        let url = `quotes/filter/StatusKeyword?status=${status}`;
        if (filter) {
          url += `&filter=${filter}`;
        }
        return url;
      },
      providesTags: ["quotes"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateQuoteDraftMutation,
  useCreateQuoteMutation,
  useGetQuotesQuery,
  useUpdateQuoteStatusMutation,
  useGetNextQuoteNumberQuery,
  useUpdateQuoteMutation,
  useGetQuotesByStatusQuery,
} = quoteApi;
